import { type FC } from 'react';
import { SearchResultsByLocationType } from 'types/types';
import styles from './Badges.module.css';
import moment from 'moment';
import { Small } from 'components/text';

interface IListItem {
  searchResults: SearchResultsByLocationType;
}

const Badges: FC<IListItem> = ({ searchResults }) => {
  let Badges: string[] = [];

  const today = moment();
  const lastYear = moment().subtract(12, 'months');

  const openingDate = moment(searchResults.first_open, 'MMM YYYY');
  const isPreOpening = searchResults.pre_opening;
  const isFutureOpen = openingDate.isAfter(today) && !isPreOpening;
  const isPastOpen =
    openingDate.isAfter(lastYear) && openingDate.isBefore(today);

  if (isFutureOpen) {
    Badges.push(`Opening ${openingDate.format('MMM YYYY')}`);
  }
  if (isPastOpen) {
    Badges.push(`Opened ${openingDate.format('MMM YYYY')}`);
  }

  if (Badges.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      {Badges.map((badge, index) => (
        <div key={index} className={styles.badge}>
          <Small color="white" weight="demiBold">
            {badge}
          </Small>
        </div>
      ))}
    </div>
  );
};

export default Badges;
